import { Dialog } from '@base-ui/react/dialog'
import { PopUpWindow } from '@components/PopUp/PopUpWindow.component'
import { useTranslation } from 'react-i18next'

import { Container, LabelDescription, LabelHint } from './PopUpDelete.styled'

import type { JSX } from 'react'

interface Props {
  title: string
  description: string
  hint?: string
  type?: 'validate' | 'destroy'

  onSubmit: () => void
  onClose: () => void
  onOpen?: () => void

  onSubmitLabel?: string
}

export const PopUpDelete = (props: Props): JSX.Element => {
  const { title, description, hint, onSubmit, onOpen, onClose, onSubmitLabel, type = 'destroy' } = props

  const { t } = useTranslation()

  return (
    <PopUpWindow
      alert
      type={type}
      title={title}
      onSubmitLabel={onSubmitLabel || t('components_PopUpDelete_label_submit')}
      onOpen={onOpen}
      onClose={onClose}
      onSubmit={onSubmit}
    >
      <Container>
        <Dialog.Description render={<LabelDescription />}>{description}</Dialog.Description>
        {hint && <LabelHint>{hint}</LabelHint>}
      </Container>
    </PopUpWindow>
  )
}
